import { render, staticRenderFns } from "./lote.vue?vue&type=template&id=472fbaa5"
import script from "./lote.vue?vue&type=script&lang=js"
export * from "./lote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports